import { KsService } from '@siclop/kstone-vue'

export class ServiceTypeService extends KsService {
  protected static mainUrl = '/service-types'
}
